import AddIcon from "@mui/icons-material/Add";
import BackspaceIcon from "@mui/icons-material/Backspace";
import {PuiDefaultPage, PuiFormikForm, PuiGrid} from "@portnet/ui";
import {Formik} from "formik";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {generatePath, useNavigate} from "react-router-dom";
import AppAutocomplete from "../../../../common/components/inputs/AppAutocomplete";
import AppSelect from "../../../../common/components/inputs/AppSelect";
import AppSimpleReferentielField from "../../../../common/components/inputs/AppSimpleReferentielField";
import AppTextField from "../../../../common/components/inputs/AppTextField";
import AppButton from "../../../../common/components/ui/AppButton";
import AppSection from "../../../../common/components/ui/AppSection";
import {
    DETAIL_CONSULTATION_PACKAGES_PAGE_ROUTE,
    GESTION_PACKAGES_PAGE_ROUTE,
} from "../../../../common/constants/routerConstants";
import useLocalReferentiel from "../../../../common/hooks/useLocalReferentiel";
import * as localReferentielKeys from "../../../../common/localReferentiel/others/localReferentielKeys";
import * as nouveauPackageFormNames from "../others/nouveauPackageFormNames";
import {nouveauPackageInitialValues} from "../others/nouveauPackageInitialValues";
import {nouveauPackageValidationSchema} from "../others/nouveauPackageValidationSchemas";
import {
    creationNouveauPackageAction,
    creationNouveauPackageReinitializationAction,
} from "../state/nouveauPackageActions";

const NavigationActions = ({ formRef }) => {
  return (
    <PuiGrid container>
      <PuiGrid item>
        <AppButton
          color="tertiary"
          startIcon={<BackspaceIcon />}
          onClick={() => {
            formRef.current.resetForm();
          }}
        >
          Effacer
        </AppButton>
      </PuiGrid>
      <PuiGrid item>
        <AppButton
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => {
            formRef.current.submitForm();
          }}
        >
          Créer
        </AppButton>
      </PuiGrid>
    </PuiGrid>
  );
};

const NouveauPackagePage = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const formRef = React.useRef();

  const {
    content: createdPackage,
    isLoading: isCreationNouveauPackageLoading,
    isSuccessed: isCreationNouveauPackageSuccessed,
    hasError: hasCreationNouveauPackageError,
  } = useSelector(
    (state) => state.packages.nouveauPackage.creationNouveauPackage
  );

  const [rolesOperateurOptions] = useLocalReferentiel([
    localReferentielKeys.ROLES_OPERATEUR_LOCAL_REFERENTIEL_KEY,
  ]);

  const submitHandler = (values) => {
    dispatch(creationNouveauPackageAction(values));
  };

  React.useEffect(() => {
    if (hasCreationNouveauPackageError) {
      dispatch(creationNouveauPackageReinitializationAction());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasCreationNouveauPackageError]);

  React.useEffect(() => {
    if (isCreationNouveauPackageSuccessed) {
      navigate(
        generatePath(DETAIL_CONSULTATION_PACKAGES_PAGE_ROUTE, {
          packageId: createdPackage.id,
        })
      );
      dispatch(creationNouveauPackageReinitializationAction());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreationNouveauPackageSuccessed]);

  const [isDisabledCritere, setIsDisabledCritere] = useState(true);
  const [isDisabledParametreDecompte, setIsDisabledParametreDecompte] =
    useState(true);
  const [isDisabledReconduction, setIsDisabledReconduction] = useState(false);
  const [isHideNbrTransaction, setIsHideNbrTransaction] = useState(true);
  const [isDisabledFraisTransaction, setDisabledFraisTransaction] =
    useState(true);

  const handlChangeRoleOperateur = (event) => {
    if (event === null) {
      setIsDisabledCritere(false);
      setIsDisabledParametreDecompte(false);
      formRef?.current.setFieldValue(
        nouveauPackageFormNames.CRITERE_FACTURATION_FORM_NAME,
        null
      );
      formRef?.current.setFieldValue(
        nouveauPackageFormNames.PARAMETRE_DECOMPTE_FORM_NAME,
        null
      );
    } else {
      setIsDisabledCritere(true);
      setIsDisabledParametreDecompte(true);
      if (
        event?.code === "ROLE_VUPORTUARIA_IMPORTADOR" ||
        event?.code === "ROLE_VUPORTUARIA_BANCO"
      ) {
        formRef?.current.setFieldValue(
          nouveauPackageFormNames.CRITERE_FACTURATION_FORM_NAME,
          "TI"
        );
        formRef?.current.setFieldValue(
          nouveauPackageFormNames.PARAMETRE_DECOMPTE_FORM_NAME,
          "ENVOI_DOMICILIATION"
        );
      } else if (event?.code === "ROLE_VUPORTUARIA_TRANSITARIO") {
        formRef?.current.setFieldValue(
          nouveauPackageFormNames.CRITERE_FACTURATION_FORM_NAME,
          "DUM"
        );
        formRef?.current.setFieldValue(
          nouveauPackageFormNames.PARAMETRE_DECOMPTE_FORM_NAME,
          "INTEGRATION_DUM"
        );
      } else {
        formRef?.current.setFieldValue(
          nouveauPackageFormNames.CRITERE_FACTURATION_FORM_NAME,
          "ESCALE"
        );
        formRef?.current.setFieldValue(
          nouveauPackageFormNames.PARAMETRE_DECOMPTE_FORM_NAME,
          "ENVOI_MANIFESTE"
        );
      }
    }
  };

  const handlChangeTypePaiement = (event) => {
    setIsDisabledReconduction(false);
    if (event?.code === "PREPAYE") {
      formRef?.current.setFieldValue(nouveauPackageFormNames.RECONDUCTION_PACKAGE_FORM_NAME, false);
      setIsDisabledReconduction(true);
    }
  };
  const handlChangeTransactionAutorise = (event) => {
    if (event?.code === "LIMITE") {
      formRef?.current.setFieldValue(
        nouveauPackageFormNames.NOMBRE_TRANSACTIONS_FORM_NAME,
        ""
      );
      setIsHideNbrTransaction(true);
    } else if (event?.code === "ILLIMITE") {
      formRef?.current.setFieldValue(
        nouveauPackageFormNames.NOMBRE_TRANSACTIONS_FORM_NAME,
        0
      );
      setIsHideNbrTransaction(false);
    }
  };
  const handlChangeTypeFraisService = (event) => {
    setDisabledFraisTransaction(true);
    formRef?.current.setFieldValue(
      nouveauPackageFormNames.FRAIS_TRANSACTION_FORM_NAME,
      ""
    );
    if (event?.code === "SANS") {
      setDisabledFraisTransaction(true);
    } else if (event?.code === "FIXE") {
      setDisabledFraisTransaction(false);
    }
  };
  return (
    <PuiDefaultPage
      title="Nouveau package"
      titleIcon={<AddIcon />}
      trace={["Accueil", "Nouveau package"]}
      navActions={<NavigationActions formRef={formRef} />}
      loading={isCreationNouveauPackageLoading}
      topNav
      bottomNav
      retour
      onRetour={() => navigate(GESTION_PACKAGES_PAGE_ROUTE)}
    >
      <AppSection title="Nouveau package">
        <Formik
          initialValues={nouveauPackageInitialValues}
          validationSchema={nouveauPackageValidationSchema}
          onSubmit={submitHandler}
          innerRef={formRef}
        >
          <PuiFormikForm>
            <PuiGrid container>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppAutocomplete
                  label="Rôle de l'opérateur"
                  name={nouveauPackageFormNames.ROLE_OPERATEUR_FORM_NAME}
                  options={rolesOperateurOptions.content}
                  loading={rolesOperateurOptions.isLoading}
                  error={rolesOperateurOptions.hasError}
                  helperText={rolesOperateurOptions.error}
                  getOptionLabel={(option) => option.description}
                  getOptionValue={(option) => option.id}
                  onChange={handlChangeRoleOperateur}
                  required
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppSimpleReferentielField
                  autocomplete
                  searchKey="LISTE_CRITERES_FACTURATION"
                  label="Critère de facturation"
                  name={nouveauPackageFormNames.CRITERE_FACTURATION_FORM_NAME}
                  getOptionLabel={(option) => option?.description}
                  getOptionValue={(option) => option?.code}
                  required
                  disabled={isDisabledCritere}
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppSimpleReferentielField
                  autocomplete
                  searchKey="LISTE_PARAMETRES_DECOMPTE"
                  label="Paramètre de décompte"
                  name={nouveauPackageFormNames.PARAMETRE_DECOMPTE_FORM_NAME}
                  getOptionLabel={(option) => option.description}
                  getOptionValue={(option) => option.code}
                  required
                  disabled={isDisabledParametreDecompte}
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppSimpleReferentielField
                  autocomplete
                  searchKey="LISTE_PAIEMENT_PACKAGE"
                  label="Type de paiement"
                  name={nouveauPackageFormNames.TYPE_PAIEMENT_FORM_NAME}
                  getOptionLabel={(option) => option.description}
                  getOptionValue={(option) => option.code}
                  onChange={handlChangeTypePaiement}
                  required
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppSimpleReferentielField
                  autocomplete
                  searchKey="LISTE_TRANSACTIONS_AUTORISEES"
                  label="Transaction autorisée"
                  name={nouveauPackageFormNames.TRANSACTION_AUTORISEE_FORM_NAME}
                  getOptionLabel={(option) => option.description}
                  getOptionValue={(option) => option.code}
                  onChange={handlChangeTransactionAutorise}
                  required
                />
              </PuiGrid>
              {isHideNbrTransaction && (
                <PuiGrid item xs={12} sm={4} md={4}>
                  <AppTextField
                    label="Nombre de transactions"
                    name={nouveauPackageFormNames.NOMBRE_TRANSACTIONS_FORM_NAME}
                    required
                  />
                </PuiGrid>
              )}
              {!isHideNbrTransaction && (
                <PuiGrid item xs={12} sm={4} md={4}>
                  <AppTextField
                    formik={false}
                    label="Nombre de transactions"
                    required
                    value={"Illimité"}
                    disabled
                  />
                </PuiGrid>
              )}
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppTextField
                  label="Frais d'accès annuel en MAD (TTC)"
                  name={nouveauPackageFormNames.FRAIS_ACCES_ANNUEL_FORM_NAME}
                  required
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppSimpleReferentielField
                  autocomplete
                  searchKey="LISTE_DEBUT_VALIDITE_PACKAGE"
                  label="Début de validité"
                  name={
                    nouveauPackageFormNames.DEBUT_VALIDITEE_PACKAGE_FORM_NAME
                  }
                  getOptionLabel={(option) => option.description}
                  getOptionValue={(option) => option.code}
                  filterFunc={(option) => option.code !== "DEBUT_ANNE_AVENIR"}
                  required
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppSimpleReferentielField
                  autocomplete
                  searchKey="LISTE_STATUS_PACKAGE"
                  label="Statut du package"
                  name={nouveauPackageFormNames.STATUS_PACKAGE_FORM_NAME}
                  getOptionLabel={(option) => option.description}
                  getOptionValue={(option) => option.code}
                  filterFunc={(option) => option.code !== "DELETED"}
                  required
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppSimpleReferentielField
                  autocomplete
                  searchKey="LISTE_FRAIS_SERVICE_PACKAGE"
                  label="Type de frais de service"
                  name={
                    nouveauPackageFormNames.TYPE_FRAIS_SERVICE_PACKAGE_FORM_NAME
                  }
                  getOptionLabel={(option) => option.description}
                  getOptionValue={(option) => option.code}
                  filterFunc={(option) => option.code !== "PAR_TRANCHE"}
                  onChange={handlChangeTypeFraisService}
                  required
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppSelect
                  name={nouveauPackageFormNames.RECONDUCTION_PACKAGE_FORM_NAME}
                  label="Reconduction"
                  options={[
                    { description: "Non", value: false },
                    { description: "Oui", value: true },
                  ]}
                  getOptionLabel={(option) => option.description}
                  getOptionValue={(option) => option.value}
                  disabled={isDisabledReconduction}
                  value={false}
                  required
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppTextField
                  label="Frais transaction en MAD"
                  name={nouveauPackageFormNames.FRAIS_TRANSACTION_FORM_NAME}
                  disabled={isDisabledFraisTransaction}
                  required={!isDisabledFraisTransaction}
                />
              </PuiGrid>
              <PuiGrid item xs={12}>
                <AppTextField
                  label="Description du package"
                  name={nouveauPackageFormNames.DESCRIPTION_FORM_NAME}
                  multiline
                  rows={6}
                  required
                />
              </PuiGrid>
            </PuiGrid>
          </PuiFormikForm>
        </Formik>
      </AppSection>
    </PuiDefaultPage>
  );
};

export default NouveauPackagePage;
